import { render, staticRenderFns } from "./ModalComprovantes.vue?vue&type=template&id=4098423c&"
import script from "./ModalComprovantes.vue?vue&type=script&lang=js&"
export * from "./ModalComprovantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports